<!--{{message | async | json}}-->
<span id="triangle-up"></span>
<div class="notification-header">
  <span class="notifications-span">
  Notifications
</span>
  <span class="enable-disable">Browser Notifications</span>
  <mat-slide-toggle [checked]="validToken" (change)="requestPermission($event)"></mat-slide-toggle>
</div>
<div class="notifications-card empty-state" *ngIf="notifications?.length === 0">
  <img src="assets/icons/icon-bell.png">
  <div class="no-notifications">
    <span class="card-title">No notifications yet</span>
    <div class="card-content">
      When you get notifications, they'll show up here.
    </div>
  </div>
</div>
<div class="notifications-card" *ngFor="let item of notifications?.slice(0, elementsNumber)"
     [ngStyle]="{'background-color':  item.read ? 'white' : '#e5f9fe' }">
  <span class="card-title">{{item.title}} <span
    class="datetime">{{datePipe.transform(item.createDate, dateFormat)}}</span></span>
  <div class="card-content">
    {{item.content}}
  </div>
  <button class="card-button" mat-button (click)="redirectTo(item.module)">
    <span class="card-view" [ngStyle]="{'color':  item.read ? '#333' : '#0193e8'}">
      View
    </span>
  </button>
</div>
<button class="btn-footer" *ngIf="true" (click)="redirectTo('notifications/list')">See all</button>
